import { render, staticRenderFns } from "./PriceArea.vue?vue&type=template&id=12d69ebf"
import script from "./PriceArea.vue?vue&type=script&lang=js"
export * from "./PriceArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports